module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"Forgot my password"},"pt-BR":{"title":"Esqueci minha senha"}}')
  delete Component.options._Ctor
}
